import styled from '@emotion/styled';

export const Checkbox = styled.input`
	/* Add if not using autoprefixer */
	-webkit-appearance: none;
	/* Remove most all native input styles */
	appearance: none;
	/* For iOS < 15 */
	background-color: var(--white);
	/* Not removed via appearance */
	margin: 0;

	width: 2rem;
	height: 2rem;
	border: 1px solid var(--black-20);
	border-radius: var(--spacing-1);
	cursor: pointer;
	position: relative;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

	::before {
		position: absolute;
		content: '';
		display: block;
		top: 50%;
		left: 50%;
		width: 0.75rem;
		height: 1.25rem;
		border-style: solid;
		border-color: var(--alwaysWhiteColor);
		border-width: 0 2px 2px 0;
		transform: translate(-50%, -65%) rotate(45deg);
		transform-origin: center;
		opacity: 0;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		will-change: opacity, transform, width, height, background-color, border-width;
	}

	:hover {
		border: 1px solid var(--black);
	}

	:indeterminate {
		border-color: var(--blue);
		background-color: var(--blue);

		::before {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 1rem;
			height: 2px;
			border: none;
			background-color: var(--alwaysWhiteColor);
			opacity: 1;
		}

		:hover {
			border-color: var(--blue-hover);
			background-color: var(--blue-hover);
		}
	}

	:checked {
		border-color: var(--blue);
		background-color: var(--blue);

		:hover {
			border-color: var(--blue-hover);
			background-color: var(--blue-hover);
		}

		::before {
			opacity: 1;
		}
	}

	&.error {
		border-color: var(--red);
		background-color: var(--red-10);

		:hover {
			border-color: var(--red);
		}

		:checked {
			border-color: var(--red);
			background-color: var(--red);
		}

		:indeterminate {
			border-color: var(--red);
			background-color: var(--red);

			:hover {
				border-color: var(--red);
				background-color: var(--red);
			}
		}
	}

	:disabled {
		border-color: var(--background-3) !important;
		background-color: var(--background-3) !important;
		cursor: not-allowed !important;

		:checked::before {
			border-color: var(--content-4) !important;
		}

		:indeterminate::before {
			border-color: var(--content-4) !important;
			background-color: var(--content-4) !important;
		}
	}

	/* Fix for Safari */
	@supports (-webkit-touch-callout: none) {
		::before {
			transition-property: opacity, transform, width, height, background-color, border-width;
		}
	}

	/* Fix for mobile touch devices */
	@media (hover: none) {
		:hover {
			border-color: var(--black-20);
		}

		:checked:hover,
		:indeterminate:hover {
			border-color: var(--blue);
			background-color: var(--blue);
		}

		&.error:hover,
		&.error:checked:hover,
		&.error:indeterminate:hover {
			border-color: var(--red);
		}
	}
`;
